
export default function Loading() {
  return (
    <div className="d-flex align-items-center justify-content-center flex-column flex-wrap flex-grow-1 vh-100">
      <div className="spinner spinner-1" />
      <p className="lead">Loading</p>
    </div>
  );
}
